import { createTypes } from '../../utils/helpers';

const SHELF_UNITS_FETCH: any = createTypes('SHELF_UNITS_FETCH');
export { SHELF_UNITS_FETCH };
